module.exports = __webpack_public_path__ + "static/dd-madde3-60767496c7a4f27b0f1885509558799e.png";